<div class="main-container">
  <div class="d-flex justify-content-around">
    <button
      psUiButton
      class="btn btn-primary selection-all-btn"
      (click)="onToggleAllSelections('select-all')"
    >
      Select All
    </button>
    <button
      psUiButton
      class="btn btn-primary selection-all-btn"
      (click)="onToggleAllSelections('clear-all')"
    >
      Clear All
    </button>
  </div>

  <div class="table-container">
    <ps-ui-table [data]="multiCountryPreDraftData" class="table table-striped">
      <ng-container
        psUiTableCheckboxColumn
        selectBy="survey_localization"
        [show]="true"
        [showSelectAll]="false"
        [selectedKeys]="selectedLocales"
        (selectedKeysChange)="onLocaleSelection($event)"
      ></ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header">Locale</div>
        </ng-template>
        <ng-template psUiTableCellTemplate let-survey>
          <div class="content-container justify-content-start">
            {{ survey.country_name }}
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header"></div>
        </ng-template>
        <ng-template psUiTableCellTemplate let-survey>
          <div class="content-container">
            <span class="p-1 fw-bold language-icon">
              {{ survey.language_code | uppercase }}
            </span>
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header">CPI</div>
        </ng-template>
        <ng-template psUiTableCellTemplate let-survey>
          <div class="content-container">
            {{ survey.currency_symbol }}{{ survey.cpi | number : '1.2-2' }}
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header">Feasibility</div>
        </ng-template>
        <ng-template psUiTableCellTemplate let-survey>
          <div
            class="content-container d-flex align-items-center justify-content-center flex-column"
          >
            {{ survey.feasibility | number }}
          </div>
        </ng-template>
      </ng-container>

      <ng-container psUiTableColumn width="fit">
        <ng-template psUiTableColumnCustomHeader>
          <div class="header">IR</div>
        </ng-template>
        <ng-template psUiTableCellTemplate let-survey>
          <div class="content-container">{{ survey.expected_ir }}%</div>
        </ng-template>
      </ng-container>
    </ps-ui-table>
  </div>

  <div class="p-1">
    <div
      *ngIf="isMultiCountrySingleViewEnabled"
      class="d-flex justify-content-center my-2"
    >
      <button
        [disabled]="!multiCountryPreDraftData.length"
        psUiButton
        class="btn btn-primary save-btn"
        (click)="onSingleSurveyCreation()"
        data-e2e="saveAsSingleSurvey"
      >
        Save as Single Survey
      </button>
    </div>

    <div
      *ngIf="isMultiCountryEnabled"
      class="d-flex justify-content-center my-2"
    >
      <button
        psUiButton
        class="btn btn-primary save-btn"
        (click)="onMultipleSurveysCreation()"
        psUiGtagEvent
        trackOn="click"
        action="multi_country"
        category="Tools"
        [disabled]="!multiCountryPreDraftData.length"
        [params]="{ event_label: 'Multi Country Surveys Created' }"
      >
        Save as Multiple Surveys
      </button>
    </div>
  </div>
</div>
